<template>
    <PageHeader :title="title" @back="goBack">
        <template #right-content>
            <InboxLink />
        </template>
    </PageHeader>

    <div class="flex flex-col gap-8 px-4 pt-2 pb-6">
        <div
            v-if="statisticsStore.isLoading"
            class="flex animate-pulse flex-col gap-8"
            data-testid="statistics-loading"
        >
            <div class="bg-card h-[222px]"></div>
            <div class="bg-card h-[172px]"></div>
            <div class="bg-card h-[264px]"></div>
        </div>

        <div
            v-else-if="statisticsStore.hasError"
            class="flex flex-col items-center gap-6 px-6 py-12 text-center"
        >
            <p class="text-titles text-sm">{{ $t('general.something_went_wrong') }}</p>
            <DiagonalCutButton
                variant="secondary"
                :full-width="false"
                @click="statisticsStore.fetch()"
            >
                {{ $t('general.error_retry') }}
            </DiagonalCutButton>
        </div>

        <template v-else>
            <slot name="summary"></slot>

            <div v-if="isEmpty" class="px-6 py-8 text-center" data-testid="statistics-empty">
                <div class="mb-2 text-lg font-bold text-white">
                    {{ $t('profile.no_games_played') }}
                </div>
                <div class="text-titles text-sm">{{ $t('profile.no_games_played_hint') }}</div>
            </div>
            <slot v-else></slot>
        </template>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useStatisticsStore } from '@/stores/statistics.js'
import PageHeader from '@/components/PageHeader.vue'
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'
import InboxLink from '@/components/notifications/InboxLink.vue'

export default {
    name: 'StatisticsLayout',
    components: {
        PageHeader,
        DiagonalCutButton,
        InboxLink,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        isEmpty: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useStatisticsStore),
    },
    mounted() {
        this.statisticsStore.fetch()
    },
    methods: {
        goBack() {
            this.$router.replace({
                name: this.$route.name === 'statistics' ? 'home' : 'statistics',
            })
        },
    },
}
</script>
